module.exports = __webpack_public_path__ + "img/3.265a0490.png";